var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:( _obj = {}, _obj[_vm.css.articleAuthorsList] = true, _obj[_vm.css[_vm.type]] = true, _obj )},_vm._l((_vm.items),function(author,key){return _c('li',{key:key,class:_vm.css.author},[_c('Person',{attrs:{"person":{
        name: author.title,
        image: author.photo,
        position: author.subtitle,
        url: ("/" + (author.url_alias))
      }}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }